export const ASSESSMENT_BOARD_SEARCH = 'assessment-board-search';
export const ASSESSMENT_TABLE_SEARCH = 'assessment-table-filter';
export const VENDOR_DETAIL_SEARCH = 'vendor-detail-search';